import React from 'react';
import CapsUi from './components/CapsUi';

const CapsTab = () => {
  return (
    <div className={'capsTab'}>
      <CapsUi />
    </div>
  );
};

export default CapsTab;
